import { createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../../../store/reducers/typings'
import { State } from './typings'
import { fetchOverdueActivitiesCount } from './api'

export const initialState: State = {
  overdueCount: 0,
}

export const overdueActivitiesCount = createSlice({
  name: 'overdueActivitiesCount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchOverdueActivitiesCount.fulfilled,
      (state, { payload }) => {
        state.overdueCount = payload
      },
    )
  },
})

export default overdueActivitiesCount.reducer

export const selectOverDueActivitiesCount = (state: StoreData) =>
  state.overdueActivitiesCount
